import appSlides from '../data/appSlides';
import useCarousel from '../hooks/useCarousel';

export default function AppCarousel() {
  const { activeIndex, position, isTransitionEnabled, goToSlide, goToNext, goToPrev, onTransitionEnd } =
    useCarousel(appSlides.length, 5000);
  const renderedSlides =
    appSlides.length > 1
      ? [appSlides[appSlides.length - 1], ...appSlides, appSlides[0]]
      : appSlides;

  const onPrevClick = () => {
    goToPrev();
  };

  const onNextClick = () => {
    goToNext();
  };

  return (
    <section className="App-carousel" aria-label="App images carousel">
      <div className="App-carousel-track">
        {appSlides.length > 1 ? (
          <>
            <button
              type="button"
              className="App-carousel-nav App-carousel-nav-left"
              aria-label="Previous slide"
              onClick={onPrevClick}
            >
              <img src="/img/left.svg" className="App-carousel-nav-icon" alt="" aria-hidden="true" />
            </button>

            <button
              type="button"
              className="App-carousel-nav App-carousel-nav-right"
              aria-label="Next slide"
              onClick={onNextClick}
            >
              <img src="/img/right.svg" className="App-carousel-nav-icon" alt="" aria-hidden="true" />
            </button>
          </>
        ) : null}

        <div
          className={`App-carousel-slides${isTransitionEnabled ? '' : ' no-transition'}`}
          style={{ transform: `translateX(-${position * 100}%)` }}
          onTransitionEnd={onTransitionEnd}
        >
          {renderedSlides.map((slide, index) => (
            <img
              key={`${slide.id}-${index}`}
              src={slide.image}
              className="App-carousel-image"
              alt={slide.name}
              loading={index === 0 ? 'eager' : 'lazy'}
              draggable={false}
            />
          ))}
        </div>
      </div>

      <div className="App-carousel-dots" aria-label="Slide selection">
        {appSlides.map((slide, index) => (
          <button
            key={`${slide.id}-dot`}
            type="button"
            className={`App-carousel-dot${index === activeIndex ? ' is-active' : ''}`}
            aria-label={`Go to slide ${index + 1}`}
            aria-pressed={index === activeIndex}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
}
